import { render, staticRenderFns } from "./FavoriteProducts.vue?vue&type=template&id=47650c93&scoped=true&"
import script from "./FavoriteProducts.vue?vue&type=script&lang=js&"
export * from "./FavoriteProducts.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteProducts.vue?vue&type=style&index=0&id=47650c93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47650c93",
  null
  
)

export default component.exports